import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CustomToastComponent } from './component/custom-toast/custom-toast.component';
import { ToastrModule } from 'ngx-toastr';
import {
  NgHttpLoaderComponent,
  pendingRequestsInterceptor$,
} from 'ng-http-loader';

@NgModule({
  declarations: [AppComponent, CustomToastComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgHttpLoaderComponent,
    ToastrModule.forRoot({
      toastComponent: CustomToastComponent,
      positionClass: 'toast-bottom-right',
      closeButton: true,
    }),
  ],
  providers: [
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([pendingRequestsInterceptor$])
    ),
  ],
})
export class AppModule {}
